export default "__VITE_ASSET__J5pq1Ak$__"